import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import userStore from '@/store/user';
import { HelperCore } from '@/common/helper';

const InitHolder = observer(props => {
  const { children } = props;

  useEffect(() => {
    if (userStore.isReady && !userStore.isUser) {
      if (HelperCore.getParams()?.login == 1) {
        userStore.gotoLogin();
      }
    }
  }, [userStore.isReady, userStore.isUser]);

  if (!userStore.isReady) return null;

  return <>{children}</>;
});
export default InitHolder;
